import styled from "styled-components";
import { motion } from "framer-motion";

export const ChecklistItemDisplayContainer = styled.div`
    border: 1px solid rgba(255,255,255,0.5);
    border-radius: 8px;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 8px;
    position: relative;
`;
export const TopCardContent = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;
export const LeftCardContent = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`;
export const CardContentWrapper = styled.div`
    opacity: ${(props) => props.$opacity || 1};
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
`;

export const CardNumber = styled.div`
    box-sizing: border-box;
    align-items: center;
    display: flex;
    height: 40px;
    width: fit-content;

    h4 {
        font-size: 12px;
        padding: 4px 12px;
        text-align: center;
    };
`;
export const CardDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
export const CardHeader = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    gap: 4px;

    span {
        color: rgba(255,255,255,0.4 );
    }

    h3 {
        color: #FFFFFF;
        display: inline;
        font-size: 12px;
        font-weight: 600;
    };
`;
export const QtyContent = styled.div`
    align-items: center;
    display: flex;
    gap: 12px;

    h4 {
        user-select: none;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
    }
`;

export const QtyTicker = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
`;

export const QtyButton = styled.div`
    cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${props => props.$disabled ? '0.25' : '1.0'};
    transition: opacity 0.2s ease;
    pointer-events: ${props => props.$disabled ? 'none' : 'auto'};

    &:hover {
        opacity: ${props => props.$disabled ? '0.25' : '0.7'};
    }

    img {
        height: 100%;
        width: 100%;
    }
`;

export const QtyValue = styled.h4`
    min-width: 24px;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
`;

export const CardNumberInput = styled.input`
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    color: #FFFFFF;
    font-size: 12px;
    padding: 6px 8px;
    width: 60px;
    text-align: center;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    &:focus {
        outline: none;
        border-color: rgba(255, 255, 255, 0.4);
        background: rgba(255, 255, 255, 0.15);
    }
`;
export const AttributesContainer = styled.div`
    display: flex;
    gap: 4px;
    flex-wrap: wrap;

    .card-attributes-container, .card-variations-container {
        display: flex;
        gap: 4px;
    }

    h4 {
        font-size: 10px;
        line-height: 19px;
    }
`;
export const AddBtn = styled.div`
    border: ${(props) => `1px solid ${props.$isActive ? '#FFFFFF' : '#FFFFFF66'}`};
    border-radius: 4px;
    cursor: ${(props) => props.$isActive ? 'pointer' : 'default'};
    opacity: ${(props) => props.$isActive ? '1.0' : '0.25'};
    padding: 4px 12px;
    text-align: center;
    min-width: 80px;
    white-space: nowrap;
    transition: background-color 0.15s ease-out;
    will-change: background-color;

    h4 {
        width: 100%;
        margin: 0;
        white-space: nowrap;
    };

    &:hover {
        background: ${(props) => props.$isActive ? 'rgba(255,255,255,0.2)' : ''};
    };
`;
export const ParallelConfiguration = styled.div`
    border-top: 1px solid rgba(255,255,255,0.25);
    margin-left: 32px;
    padding-top: 16px;
    padding-bottom: 8px;
`;
export const Parallels = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;
export const Parallel = styled.h5`
    border: ${(props) => `2px solid ${props.$parallelColor}`};
    border-radius: 150px;
    box-sizing: border-box;
    cursor: pointer;
    height: 30px;
    padding: 4px 12px;
    width: fit-content;
    transition: background-color 0.15s ease-out;
    will-change: background-color;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    pointer-events: auto;

    &:hover {
        background: ${(props) => `${props.$parallelColor}80`};
    };

    &.active {
        background: ${(props) => `${props.$parallelColor}80`};
    };
`;
export const SelectedParallelContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
export const ParallelDetailsContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;
export const ActionContainer = styled.div`
    display: flex;
    gap: 8px;
`;
export const DeselectButton = styled.div`
    border-radius: 50%;
    cursor: pointer;
    height: 28px;
    width: 28px;

    &:hover {
        background: rgba(255,255,255,0.25);
    };

    img {
        height: 28px;
        width: 28px;
    };
`;
export const InputContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
`;
export const InputField = styled.input`
    padding: 5px;
    background: none;
    border-radius: 4px;
    border: 1px solid #ccc;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
    outline: none;
    text-align: center;
    width: 64px;

    &::placeholder {
        color: rgba(255,255,255,0.4);
    };
`;
export const ExpandVariations = styled.h3`
    border: 1px solid #FFFFFF;
    border-radius: 100px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 10px;
    font-weight: 500;
    height: 22px;
    line-height: 14px;
    padding: 2px 8px;
    width: fit-content;

    &:hover {
        background: rgba(255,255,255,0.4);
    }
`
export const VariationRows = styled.div`
    display: flex;
    flex-direction: column;
`
export const VariationRow = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    height: 48px;
    justify-content: space-between;
    width: 100%;
`

export const EllipsisMenuWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    z-index: 10;
`;

export const EllipsisButton = styled.div`
    align-items: center;
        border-radius: 4px;
    cursor: ${(props) => props.$isActive ? 'pointer' : 'default'};
    display: flex;
    justify-content: center;
    opacity: ${(props) => props.$isActive ? '1.0' : '0.25'};
    padding: 4px 8px;
    transition: background-color 0.15s ease-out;
    width: 32px;
    height: 32px;

    &:hover {
        background: ${(props) => props.$isActive ? 'rgba(255,255,255,0.2)' : ''};
    };
`;

export const EllipsisDropdownMenu = styled(motion.div)`
    background: transparent;
    border: none;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    overflow: visible;
    position: fixed;
    width: 160px;
    z-index: 1000;
    max-height: calc(100vh - 20px);
`;

export const EllipsisMenuContent = styled.div`
    background-color: transparent;

    div {
        height: 8px;
    }

    ul {
        background-color: rgba(255,255,255,0.2);
        border-radius: 12px;
        list-style-type: none;
        margin: 0;
        padding: 4px;
        border: 1px solid rgba(255, 255, 255, 0.2);
    }
`;

/* Friend view: read-only stats (Total Quantity, Variations Collected) */
export const FriendStatsContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 20px;
    height: 100%;
    justify-content: flex-end;
`;
export const FriendStat = styled.div`
    align-items: baseline;
    display: flex;
    gap: 6px;
`;
export const FriendStatLabel = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 11px;
    font-weight: 500;
`;
export const FriendStatValue = styled.span`
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 600;
`;
